import { render, staticRenderFns } from "./OfferChangeHistory.vue?vue&type=template&id=3ca92a48&scoped=true&"
import script from "./OfferChangeHistory.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OfferChangeHistory.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OfferChangeHistory.vue?vue&type=style&index=0&id=3ca92a48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca92a48",
  null
  
)

export default component.exports